<template>
    <div>
        <HeaderStock header="คลัง" :img_header="header_image" link_back="alllot"/>
        <MenuStockList/>
        <LotDetailInList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockList from '@/components/menuadmin/stock/stocklist/MenuStockList.vue'
import LotDetailInList from '@/components/menuadmin/stock/stocklist/LotDetailInList.vue'

export default {
    name:'lotDetailIn',
    components:{
        HeaderStock,
        MenuStockList,
        LotDetailInList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>